module.exports = __webpack_public_path__ + "images/product-badges/product-badge-ai-38104b7a8a324f2e0320c0a5a9590a46.webp";